import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./SidebarButton.scss";

type SidebarButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

export function SidebarButton({
  className = "",
  children,
  ...props
}: SidebarButtonProps) {
  return (
    <button className={`sidebar-button ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}
